module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a46641e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/App.vue
// module id = 1925
// module chunks = 0